/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2021-04-07 15:05:46
 * @LastEditors: linxi
 * @LastEditTime: 2025-09-15 17:58:57
 */
import { Form, Input, Select, Button, Row, Col, Space, Checkbox, Popover, Radio, DatePicker } from 'antd'
import React, { useContext, useEffect, useState } from 'react'
import { SearchOutlined, CaretDownFilled } from '@ant-design/icons'
import { FieldData } from '../../models/fielddata'
import { examinePageParams } from '../../services/examine'
import {
  BillingCategoryName,
  TreatmentBillingCategories,
} from '../../models/billingCategory'
import { useSelector } from 'react-redux'
import {
  selectInsuranceArray,
  selectTenantName,
} from '../../app/applicationSlice'
import { FilterIconOutlined } from '../../compnents/icons/Icons'
import styles from './Examinetreat.module.css'
import { ThemeContext } from '../../theme/ThemeContext'
import { DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import moment from 'moment'
const { Option } = Select

const { RangePicker } = DatePicker
export const ExamineQuery = (props: {
  loading?: any
  onValueChange: (queries: examinePageParams) => void
}) => {
  const [form] = Form.useForm()

  const theme = useContext(ThemeContext)

  const tenantName = useSelector(selectTenantName)

  const [popoverForm] = Form.useForm()

  const [open, setOpen] = useState(false)

  const DefaultFields: FieldData[] = [
    {
      name: 'name',
      value: undefined,
    },
    {
      name: 'state',
      value: undefined,
    },
    {
      name: 'billingCategory',
      value: undefined,
    },
  ]

  const [fields, setFields] = useState(DefaultFields)


  const insuranceArray = useSelector(selectInsuranceArray)

  const dataParams = JSON.parse(sessionStorage.getItem('/examinetreat') || '{}')

  useEffect(() => {
    if (insuranceArray.length) {
      form.setFieldsValue({
        insuranceCode: insuranceArray[0].insuranceCode,
      })
    }
  }, [insuranceArray])
  useEffect(() => {
    if (Object.keys(dataParams).length) {
      form.setFieldsValue({
        state: 1,
        ...dataParams
      })
      popoverForm.setFieldsValue({
        isLimitPrice: dataParams?.isLimitPrice == 1 ? ['1'] : dataParams?.isLimitPrice === 0 ? ['0'] : dataParams?.isLimitPrice === 2 ? ['0','1'] : [],
        gtPrice: dataParams?.gtPrice === 1 ? ['1'] : [],
        ltPrice: dataParams?.ltPrice === 1 ? ['1'] : [],
        eqPrice: dataParams?.eqPrice === 1 ? ['1'] : [],
        ltCostPrice: dataParams?.ltCostPrice === 1 ? ['1'] : [],
        gtCostPrice: dataParams?.gtCostPrice === 1 ? ['1'] : [],
        eqCostPrice: dataParams?.eqCostPrice === 1 ? ['1'] : [],
        complexPrice: dataParams?.complexPrice === 1 ? ['1'] : [],
        lastUpdateTime: dataParams?.lastUpdateTimeStart
          ? [moment(dataParams?.lastUpdateTimeStart), moment(dataParams?.lastUpdateTimeEnd)]
          : [],
      })
    } else {
      form.setFieldsValue({
        state: 1,
      })
    }
    form.submit()
  }, [])

  const refresh = () => {
    const gtPrice: any = popoverForm.getFieldsValue()?.gtPrice
    const ltPrice: any = popoverForm.getFieldsValue()?.ltPrice
    const eqPrice: any = popoverForm.getFieldsValue()?.eqPrice
    const ltCostPrice: any = popoverForm.getFieldsValue()?.ltCostPrice
    const gtCostPrice: any = popoverForm.getFieldsValue()?.gtCostPrice
    const eqCostPrice: any = popoverForm.getFieldsValue()?.eqCostPrice
    const complexPrice: any = popoverForm.getFieldsValue()?.complexPrice

    const isLimitPriceValue: any = popoverForm.getFieldsValue()?.isLimitPrice
    const lastUpdateTime: any = popoverForm.getFieldsValue()?.lastUpdateTime
    const lastUpdateTimeStart = lastUpdateTime?.[0]
      ? lastUpdateTime?.[0]?.format(DateTimeFormatSimpleOnlyOne)
      : undefined
    const lastUpdateTimeEnd = lastUpdateTime?.[1]
      ? lastUpdateTime?.[1]?.format(DateTimeFormatSimpleOnlyOne)
      : undefined

    const data = {
      ...dataParams,
      ...popoverForm.getFieldsValue(),
      current: 1,
      lastUpdateTimeStart,
      lastUpdateTimeEnd,
      lastUpdateTime: undefined,
      ...form.getFieldsValue(),
      isLimitPrice:
        isLimitPriceValue?.join(',') == '0,1' || isLimitPriceValue?.join(',') == '1,0'
          ? 2
          : isLimitPriceValue?.join(',') == '0'
            ? 0
            : isLimitPriceValue?.join(',') == '1'
              ? 1
              : '',
      gtPrice: gtPrice?.[0] == 1 ? 1 : 0,
      ltPrice: ltPrice?.[0] == 1 ? 1 : 0,
      eqPrice: eqPrice?.[0] == 1 ? 1 : 0,
      ltCostPrice: ltCostPrice?.[0] == 1 ? 1 : 0,
      gtCostPrice: gtCostPrice?.[0] == 1 ? 1 : 0,
      eqCostPrice: eqCostPrice?.[0] == 1 ? 1 : 0,
      complexPrice: complexPrice?.[0] == 1 ? 1 : 0,
    }
    props.onValueChange(data)
  }
  return (
    <Form
      fields={fields}
      form={form}
      name='control-hooks'
      onFinish={(values) => {
        // refresh()
        props.onValueChange({
          ...dataParams,
          ...values,
          current: dataParams.current || 1,
        })
      }}
      autoComplete='off'
    >
      <Row style={{ margin: '0 0 10px 0' }} justify='space-between'>
        <Space wrap={false}>
          <Form.Item name='name' noStyle>
            <Input
              placeholder='搜索关键词'
              allowClear
              onChange={refresh}
              prefix={<SearchOutlined />}
            />
          </Form.Item>
          <Form.Item name='state' noStyle>
            <Select
              placeholder='是否注销'
              onChange={refresh}
              // suffixIcon={<CaretDownFilled />}
            >
              <Option value={0}>已注销</Option>
              <Option value={1}>未注销</Option>
            </Select>
          </Form.Item>
          <Form.Item name='billingCategory' noStyle>
            <Select
              placeholder='开票项目类型'
              allowClear
              onChange={refresh}
              // suffixIcon={<CaretDownFilled />}
            >
              {TreatmentBillingCategories.map((v) => {
                return (
                  <Option value={v} key={v}>
                    {BillingCategoryName(v)}
                  </Option>
                )
              })}
            </Select>
          </Form.Item>
          {insuranceArray.length !== 0 && (
            <>
              <Form.Item name='insuranceCode' noStyle>
                <Select
                  placeholder='医保险种'
                  // suffixIcon={<CaretDownFilled />}
                  onChange={refresh}
                >
                  {insuranceArray.map((v) => {
                    return (
                      <Option value={v.insuranceCode} key={v.id}>
                        {v.insuranceName}
                      </Option>
                    )
                  })}
                </Select>
              </Form.Item>
              {tenantName?.indexOf('余姚健齿口腔诊所有限公司') < 0 &&
                tenantName?.indexOf('余姚康民内科诊所') < 0 &&
                tenantName?.indexOf('宁波鄞州青木堂中医诊所') < 0 &&
                tenantName?.indexOf('宁波鄞州德益内科诊所有限公司') < 0 &&
                tenantName?.indexOf('宁波鄞州毅康内科诊所有限公司') < 0 && (
                  <Form.Item name='isMapping' noStyle>
                    <Select
                      placeholder='匹配状态'
                      allowClear
                      onChange={refresh}
                      // suffixIcon={<CaretDownFilled />}
                    >
                      <Option value='0'>未匹配</Option>
                      <Option value='1'>已匹配</Option>
                    </Select>
                  </Form.Item>
                )}
              <Form.Item name='chrgitmLv' noStyle>
                <Select
                  placeholder='甲乙分类'
                  allowClear
                  onChange={refresh}
                >
                  <Option value='0'>全部</Option>
                  <Option value='01'>甲类</Option>
                  <Option value='02'>乙类</Option>
                  <Option value='03'>丙类</Option>
                </Select>
              </Form.Item>
            </>
          )}
          {insuranceArray.length !== 0 && (
            <>
              <Popover
                visible={open}
                overlayClassName={styles.formQueryPopover}
                content={
                  <>
                    <Form
                      form={popoverForm}
                      onFinish={(val) => {
                        refresh()
                        setOpen(false)
                      }}
                    >
                      <Row>
                        <Col
                          style={{
                            margin: '4px 0 0 0 ',
                            width: '70px',
                            textAlign: 'right',
                          }}
                        >
                          零售价：
                        </Col>
                        <Form.Item label='' name='gtPrice'>
                          <Checkbox.Group  style={{width:'120px'}}>
                            <Checkbox value={'1'}>超医保限价</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                        <Form.Item label='' name='ltPrice'>
                          <Checkbox.Group  style={{width:'120px'}}>
                            <Checkbox value={'1'}>低于医保限价</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                        <Form.Item label='' name='eqPrice'>
                          <Checkbox.Group  style={{width:'120px'}}>
                            <Checkbox value={'1'}>等于医保限价</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            width: '70px',
                          }}
                        >
                        </Col>
                        <Form.Item label='' name='ltCostPrice'>
                          <Checkbox.Group style={{width:'120px'}}>
                            <Checkbox value={'1'}>低于进价</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                        <Form.Item label='' name='gtCostPrice'>
                          <Checkbox.Group style={{width:'120px'}}>
                            <Checkbox value={'1'}>高于进价</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                        <Form.Item label='' name='eqCostPrice'>
                          <Checkbox.Group style={{width:'120px'}}>
                            <Checkbox value={'1'}>等于进价</Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            width: '70px',
                          }}
                        >
                        </Col>
                        <Form.Item label='' name='complexPrice'>
                          <Checkbox.Group>
                            <Checkbox value={'1'}>售价和支付标准在40元及以上且高于实际进价150% </Checkbox>
                          </Checkbox.Group>
                        </Form.Item>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            margin: '4px 0 0 0 ',
                            width: '70px',
                            textAlign: 'right',
                          }}
                        >
                          医保限价：
                        </Col>
                        <Col>
                          <Form.Item label='' name='isLimitPrice'>
                            <Checkbox.Group>
                              <Checkbox value={'1'}>限价</Checkbox>
                              <Checkbox value={'0'}>不限价</Checkbox>
                            </Checkbox.Group>
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          style={{
                            margin: '4px 0 0 0 ',
                            width: '128px',
                            textAlign: 'right',
                          }}
                        >
                          最近一次修改时间：
                        </Col>
                        <Col flex={1}>
                          <Form.Item label='' name='lastUpdateTime'>
                            <RangePicker
                              style={{ width: '330px' }}
                              format={DateTimeFormatSimpleOnlyOne}
                              showTime
                              allowClear
                            />
                          </Form.Item>
                        </Col>
                      </Row>
                      <Row
                        style={{
                          height: '1px',
                          background: '#f0f0f0',
                          marginTop: '10px',
                        }}
                      ></Row>
                      <Space
                        style={{
                          display: 'flex',
                          justifyContent: 'end',
                          marginTop: '10px',
                        }}
                      >
                        <Button
                          size='middle'
                          type={'ghost'}
                          onClick={() => {
                            setOpen(false)
                          }}
                        >
                          取消
                        </Button>
                        <Button size='middle' type='primary' htmlType='submit'>
                          确定
                        </Button>
                      </Space>
                    </Form>
                  </>
                }
                title=''
                trigger='click'
                placement='bottom'
                onVisibleChange={(v) => {
                  setOpen(v)
                }}
              >
                <Form.Item name='' initialValue={'筛选'} noStyle>
                  <Button
                    style={{
                      color: theme.tc2,
                      width: '78px',
                      textAlign: 'left',
                      // overflow: 'hidden',
                      // textOverflow: 'ellipsis',
                    }}
                    icon={
                      <FilterIconOutlined
                        style={{
                          width: '14px',
                          height: '14px',
                          position: 'relative',
                          top: 2,
                          left: -2,
                          color: '#666',
                        }}
                      />
                    }
                    onClick={() => {
                      setOpen(true)
                    }}
                  >
                    筛选
                  </Button>
                </Form.Item>
              </Popover>
            </>
          )}
          <Form.Item name='allStr' noStyle>
            <Button type='primary' htmlType='submit' loading={props?.loading}>
              查询
            </Button>
          </Form.Item>
        </Space>
      </Row>
    </Form>
  )
}
